import { ImageCard } from "@common/index";
import { DATA } from "./data";
import styles from "./styles.module.scss";

export const MainGoal = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (value) => {
    console.log(value);
    onNextStep(value);
    onTrackEvent(value);
  };

  return (
    <div className={styles.container}>
      <h2>Describe your physique</h2>
      <div className={styles.cards}>
        {Object.entries(DATA).map(([title, img]) => (
          <ImageCard
            onClick={() => {
              handleNextStep(title);
              onTrackEvent(title);
            }}
            text={title}
            img={img}
            key={title}
          />
        ))}
      </div>
    </div>
  );
};
